function loadAsyncScript (url, options = {}) {
  const script = document.createElement('script')
  if (options.id) script.id = options.id
  script.setAttribute('async', '')
  script.setAttribute('defer', '')
  script.src = url
  script.onload = options.callback
  document.getElementsByTagName('head')[0].appendChild(script)
}

function loadFindation () {
  setTimeout(() => {
    loadAsyncScript('https://assets.findation.com/javascripts/widget-sep-v1.min.js')
  }, 1000)
}

function loadYouTube () {
  setTimeout(() => {
    loadAsyncScript('https://www.youtube.com/player_api')
  }, 1000)
}

function loadInHouseIframe () {
  setTimeout(() => {
    loadAsyncScript('https://cdn.timetrade.com/scripts/iframe/latest/iframe.js')
  }, 1000)
}

function loadTimetradeIFrame () {
  setTimeout(() => {
    loadAsyncScript('https://cdn.timetrade.com/scripts/iframe/latest/iframe.js')
  }, 500)
}

function loadGoogleRecaptcha (id, callbackName) {
  setTimeout(() => {
    loadAsyncScript(`https://www.google.com/recaptcha/api.js?onload=${callbackName}&render=explicit`, { id })
  }, 500)
}

function loadGoogleOneTap () {
  return new Promise((resolve) => {
    setTimeout(() => {
      loadAsyncScript('https://accounts.google.com/gsi/client', { callback: resolve })
    }, 500)
  })
}

function loadGmaps (gmapsKey) {
  return new Promise((resolve) => {
    setTimeout(() => {
      loadAsyncScript(`https://maps.googleapis.com/maps/api/js?key=${gmapsKey}&libraries=places`, { callback: resolve })
    }, 500)
  })
}

export {
  loadFindation,
  loadYouTube,
  loadTimetradeIFrame,
  loadGoogleRecaptcha,
  loadGoogleOneTap,
  loadGmaps,
  loadAsyncScript,
  loadInHouseIframe
}
